// ============================================================================
// useNavBadges — the live "needs my attention" counts that drive nav badges.
// Centralised so the sidebar (nav-shell) and the hub layouts/overview render
// the same numbers, and so hub badges can bubble up the SUM of their children.
//
// Each underlying hook self-handles the no-auth case (RLS returns 0 rows) and
// is React-Query backed, so calling them from several components shares cache.
// ============================================================================

// AM Collect archived 2026-07-02 — pending-submission badge removed.
//
// CW-I Phase 1a, 2026-08-10: the My Work badge moved off useMyWorkCount (which
// counted `waiting_on_me` off the legacy get_my_work RPC) and onto
// useNotificationBadge, so the header bell and this badge are literally the
// same number. Two counters that "should" agree eventually do not; one counter
// cannot disagree with itself.
import { useMyWorkCount } from './use-my-work-count';
import { useIncentivePendingReviewCount } from '../modules/incentive/hooks/use-incentive-data';
import type { BadgeKey } from './nav-config';

export type NavBadgeCounts = Record<BadgeKey, number>;

export function useNavBadges(): NavBadgeCounts {
  // item #650 / TCSD-0189 ruling 7: the red number counts only things to do,
  // in the person's starting view — the same rows My Work lists. Never news.
  const myWork = useMyWorkCount();
  const incentive = useIncentivePendingReviewCount();
  return { myWork, incentive };
}
